import { Injectable } from '@angular/core';
import { BrowserModule, platformBrowser } from '@angular/platform-browser'

import { REGIONS } from './regions';
import { REGIONS_I } from './regions_i';
import { RoofModel } from 'app/model/roof.model';

declare var google: any;

/**
 * Calculates basic values:
 * - roof area,
 * - usłonecznienie,
 * - nasłonecznienie.
 */

@Injectable()
export class AnalysisService {

  poly1950: google.maps.Polygon;
  poly1850: google.maps.Polygon;
  poly1650: google.maps.Polygon;
  poly1550: google.maps.Polygon;

  poly1000: google.maps.Polygon;
  poly1100: google.maps.Polygon;
  poly1200: google.maps.Polygon;

  selectedRoof: google.maps.Polygon;
  // roofArea: number;
  uslonecznienie: number;
  I_g: number;

  /**
   * Obiekt reprezentuje fragment dachu wybrany przez system
   */
  // currentRoof: RoofModel;

  /**
   * Obiekty reprezetujące wszystkie części dachu
   */
  allPolygons: RoofModel[];

  constructor() {
    this.resetPolygons();
  }


  getDachLocation() {
    return this.allPolygons[0].overlay.getPath().getAt(0);
  }

  resetPolygons() {
    this.allPolygons = new Array();
  }

  getRoofArea() {
    // return this.currentRoof ? this.currentRoof.area : 0;
    let area = 0;
    for (const r of this.allPolygons) {
      area += r.area;
    }
    return area;
  }

  getUslonecznienie() {
    return this.uslonecznienie;
  }

  getI_g() {
    return this.I_g;
  }

  initPolygons(): void {
    if (!this.poly1950) {
      this.poly1950 = new google.maps.Polygon({ paths: [REGIONS.pathA, REGIONS.pathB, REGIONS.pathC, REGIONS.pathD, REGIONS.pathE] });
      this.poly1850 = new google.maps.Polygon({ paths: [REGIONS.pathF, REGIONS.pathG] });
      this.poly1650 = new google.maps.Polygon({ paths: [REGIONS.pathL, REGIONS.pathH] });
      this.poly1550 = new google.maps.Polygon({ paths: [REGIONS.pathM, REGIONS.pathI] });
    }
  }

  initPolygonsI(): void {
    if (!this.poly1000) {
      this.poly1000 = new google.maps.Polygon({ paths: [REGIONS_I.path1000] });
      this.poly1100 = new google.maps.Polygon({ paths: [REGIONS_I.path1100, REGIONS_I.path1100_2] });
      this.poly1200 = new google.maps.Polygon({ paths: [REGIONS_I.path1200] });
    }
  }

  calcI_gFor(lat: number, lng: number): number {
    let insolation = 900;
    this.initPolygonsI();
    const position = new google.maps.LatLng(lat, lng);

    if (google.maps.geometry.poly.containsLocation(position, this.poly1200)) {
      insolation = 1200;
    } else if (google.maps.geometry.poly.containsLocation(position, this.poly1100)) {
      insolation = 1100;
    } else if (google.maps.geometry.poly.containsLocation(position, this.poly1000)) {
      insolation = 1000;
    }
    this.I_g = insolation;
    return insolation;
  }

  calcInsFor(lat: number, lng: number): number {
    this.initPolygons();
    const position = new google.maps.LatLng(lat, lng);
    let insolationH = 1750;
    if (google.maps.geometry.poly.containsLocation(position, this.poly1950)) {
      insolationH = 1950;
    } else if (google.maps.geometry.poly.containsLocation(position, this.poly1850)) {
      insolationH = 1850;
    } else if (google.maps.geometry.poly.containsLocation(position, this.poly1650)) {
      insolationH = 1650;
    } else if (google.maps.geometry.poly.containsLocation(position, this.poly1550)) {
      insolationH = 1550;
    };
    this.uslonecznienie = insolationH;
    return insolationH;
  }


  /**
   * Compute usefull area of the roof part as 90% of the total roof part area.
   * @param thePath
   */
  computeArea(thePath: any) {
    return 0.9 * google.maps.geometry.spherical.computeArea(thePath);
  }
}





// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/analysis.service.ts